var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterestBlue = function SvgPinterestBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.656)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.759,
    cy: 25.759,
    r: 25.759,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M24.097 29.665a5.484 5.484 0 0 0 5.152 1.828 7.229 7.229 0 0 0 4.57-3.075 11.05 11.05 0 0 0 1.829-5.318 9.224 9.224 0 0 0-5.235-9.057c-3.823-1.662-9.224-.831-12.05 2.41a11.156 11.156 0 0 0-2.16 3.573 6.893 6.893 0 0 0 .084 4.985 6.486 6.486 0 0 0 1.329 1.995c.166.083 1.911 1.246 1.911 1.08 0-.166.416-1.33.582-1.911a1 1 0 0 0-.166-.831 5.151 5.151 0 0 1-.831-4.404 6.817 6.817 0 0 1 2.991-3.823A6.651 6.651 0 0 1 29 16.951c2.576 1.496 2.991 4.82 2.41 7.645a7.232 7.232 0 0 1-1.247 2.825 3.487 3.487 0 0 1-2.825 1.413 2.16 2.16 0 0 1-1.994-2.825l.914-3.49c.25-.998.498-1.995-.166-2.826a2.326 2.326 0 0 0-1.995-.83 3.072 3.072 0 0 0-2.492 2.825 6.637 6.637 0 0 0 .498 3.323l-1.828 7.313a11.256 11.256 0 0 0-.25 3.324l.167 2.492a.333.333 0 0 0 .582.167l1.246-1.995a10.576 10.576 0 0 0 1.413-3.323l.664-3.324z"
  }))));
};
export default SvgPinterestBlue;